export default "<div>\n  {{TypeInComponent?.Nom}}\n</div>\n";